// **  Initial State
const initialState = {
    allData: [],
    selected: null
}

const socialReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SOCIAL':
            return { ...state, allData: action.data }
        case 'ADD_SOCIAL':
            return { ...state, allData:[...state.allData.concat(action.data)]  }
        case 'SELECTED_SOCIAL':
            return { ...state, selected: action.data }
        case 'UPDATE_SOCIAL':
            return {
                ...state,
                allData: [
                    ...state.allData.filter(category => category.id !== action.data.id),
                    action.data
                ]
            }
        case 'DELETE_SOCIAL':
            return {
                ...state,
                allData: state.allData.filter(category => {return category.id !== action.data.deleteitems} )
            }
        default:
            return state
    }
}

export default socialReducer
